module.exports = __webpack_public_path__ + "static/img/tv.355b4d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/tv.png
// module id = 1103
// module chunks = 1